import React from "react";
import { Button } from "reactstrap";
import { useCookieConsent } from "./CookieConsentProvider";
import mapPreview from "../../assets/eksiogluPictures/harita.png";
import videoPreview from "../../assets/eksiogluPictures/videoBg.png";

export default function ThirdPartyGate({
  title,
  children,
  height = 220,
  type,
  mapUrl,
}) {
  const { consent, setThirdPartyMedia } = useCookieConsent();
  const allowed = consent.thirdPartyMedia === true;

  if (allowed) return children;

  const isMap = type === "map";
  const isVideo = type === "video";

  // Default görünüm
  if (!isMap && !isVideo) {
    return (
      <div
        style={{
          height,
          borderRadius: 14,
          background: "rgba(15,23,42,0.04)",
          border: "1px solid rgba(15,23,42,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 420 }}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>{title}</div>
          <div style={{ fontSize: 13, color: "#475569", marginBottom: 10 }}>
            Bu içerik üçüncü taraf hizmetler tarafından sağlanır. Görüntülemek
            için izin vermeniz gerekir.
          </div>
          <Button
            color="info"
            className="btn-raised btn-round"
            onClick={() => setThirdPartyMedia(true)}
          >
            İzin ver ve göster
          </Button>
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 8 }}>
            Detay:{" "}
            <a href="/cerez-politikasi" style={{ textDecoration: "underline" }}>
              Çerez Politikası
            </a>
          </div>
        </div>
      </div>
    );
  }

  const previewImg = isMap ? mapPreview : videoPreview;
  const titleText = title || (isMap ? "Harita" : "Video");
  const descriptionText = isMap
    ? `Haritayı görüntülemek için Üçüncü Taraf İçerikler izni vermeniz gerekir. Bu izin, Google Haritalar gibi hizmetlerin çalışmasını sağlar.`
    : `Videoyu görüntülemek için Üçüncü Taraf İçerikler izni vermeniz gerekir. Bu izin, YouTube gibi hizmetlerin çalışmasını sağlar.`;

  const primaryBtnText = isMap
    ? "Çerezlere izin ver ve konumu gör"
    : "Çerezlere izin ver ve videoyu izle";

  return (
    <div
      className="relative overflow-hidden rounded-[14px] border border-[rgba(15,23,42,0.10)] bg-[rgba(15,23,42,0.06)]"
      style={{ height }}
    >
      {/* Background preview */}
      {previewImg ? (
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${previewImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(4px)",
            transform: "scale(1.06)",
            opacity: 0.85,
          }}
        />
      ) : (
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, rgba(2,132,199,0.12), rgba(15,23,42,0.08))",
          }}
        />
      )}

      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(15,23,42,0.35), rgba(15,23,42,0.45))",
        }}
      />

      {/* Content */}
      <div className="relative z-[2] flex h-full items-center justify-center px-3 py-3 text-center text-white sm:px-4 sm:py-4">
        <div className="max-w-[520px]">
          <div className="mb-1.5 font-extrabold text-[13px] leading-tight sm:mb-2 sm:text-[14px] md:text-[16px]">
            {titleText}
          </div>

          <div className="text-[10.5px] leading-snug opacity-95 sm:text-[11px] sm:leading-snug md:text-[13px] md:leading-[1.5] md:opacity-90">
            {isMap || isVideo ? (
              <>
                {isMap ? (
                  <>
                    Haritayı görüntülemek için{" "}
                    <strong>Üçüncü Taraf İçerikler</strong> izni vermeniz
                    gerekir. Bu izin, Google Haritalar gibi hizmetlerin
                    çalışmasını sağlar.
                  </>
                ) : (
                  <>
                    Videoyu görüntülemek için{" "}
                    <strong>Üçüncü Taraf İçerikler</strong> izni vermeniz
                    gerekir. Bu izin, YouTube gibi hizmetlerin çalışmasını
                    sağlar.
                  </>
                )}
              </>
            ) : (
              descriptionText
            )}
          </div>

          <div className="mt-2.5 flex flex-wrap justify-center gap-2 sm:mt-3 sm:gap-2.5">
            <Button
              color="info"
              className="btn-raised btn-round !font-extrabold !text-[10.5px] !px-3 !py-2 sm:!text-[11px] sm:!px-4 md:!text-[13px] md:!px-4 md:!py-2.5"
              onClick={() => setThirdPartyMedia(true)}
            >
              {primaryBtnText}
            </Button>

            {isMap && mapUrl ? (
              <a
                href={mapUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center rounded-full border border-white/35 bg-white/10 font-extrabold text-[10.5px] px-3 py-2 text-white no-underline sm:text-[11px] sm:px-4 md:text-[13px] md:px-4 md:py-2.5"
              >
                Google Haritalar’da Aç
              </a>
            ) : null}
          </div>

          <div className="mt-2 text-[10px] opacity-85 sm:mt-2.5 sm:text-[10.5px] md:mt-3 md:text-[12px]">
            Detaylı bilgi:{" "}
            <a
              href="/cerez-politikasi"
              className="font-extrabold underline underline-offset-4 text-white"
            >
              Çerez Politikası
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
